// Web strings for the 2026-10-18 parity wave's settings package (shared/API.md §41.2, §41.5, §41.7,
// §41.9, §41.10), BOTH languages. No Apple keys exist for these yet; when the native tables gain
// them, move the wording there and generate.
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    // §41.7 «No molestar» with an end
    'web.dnd.custom': 'Personalizado…',
    'web.dnd.until': 'hasta %@',
    'web.dnd.untilTomorrow': 'hasta mañana %@',
    'web.dnd.untilLater': 'hasta %1$@ %2$@',
    'web.dnd.customTitle': 'No molestar hasta…',
    'web.dnd.customDate': 'Fecha',
    'web.dnd.customTime': 'Hora',
    'web.dnd.customPast': 'Elige un momento en el futuro.',
    'web.dnd.customInvalid': 'Revisa la fecha y la hora.',
    'web.dnd.customSave': 'Activar',
    // §41.9 Pantalla
    'web.display.theme': 'Tema',
    'web.display.themeFooter': 'Solo en este navegador.',
    'web.display.clock24': 'Reloj de 24 horas',
    'web.display.clock24Hint': 'Muestra 14:30 en lugar de 2:30 p. m.',
    'web.display.timezone': 'Zona horaria',
    'web.display.timezoneAuto': 'Automática',
    'web.display.timezoneAutoHint': 'Usa la zona de este dispositivo: %@',
    'web.display.timezonePick': 'Zona',
    'web.display.timezoneFooter': 'Se guarda en tu cuenta: el servidor la usa para los correos y los recordatorios.',
    'web.display.timezoneFailed': 'No se pudo cambiar la zona horaria.',
    // §41.10
    'web.security.signOutAll': 'Cerrar sesión en todos los dispositivos',
    'web.security.signOutAllHint': 'Cierra todas tus sesiones, incluida esta. Tendrás que volver a iniciar sesión en cada dispositivo.',
    'web.security.signOutAllConfirm': '¿Cerrar todas las sesiones?',
    'web.security.signOutAllFailed': 'No se pudieron cerrar las sesiones.',
    // §41.5 Buscar › Archivos
    'web.search.scope': 'Buscar en',
    'web.search.scope.messages': 'Mensajes',
    'web.search.scope.files': 'Archivos',
    'web.search.files.start': 'Busca archivos por nombre o contenido. También puedes usar ext:pdf, in: y from:.',
    'web.search.files.empty': 'Ningún archivo coincide.',
    'web.search.files.failed': 'No se pudieron buscar archivos.',
    'web.search.files.goToMessage': 'Ir al mensaje',
    'web.search.files.open': 'Abrir archivo',
    // §41.2 Marcadores
    'web.bookmarks.bar': 'Marcadores del canal',
    'web.bookmarks.add': 'Agregar un marcador',
    'web.bookmarks.addTitle': 'Agregar marcador',
    'web.bookmarks.editTitle': 'Editar marcador',
    'web.bookmarks.link': 'Enlace',
    'web.bookmarks.linkPlaceholder': 'https://…',
    'web.bookmarks.name': 'Nombre',
    'web.bookmarks.namePlaceholder': 'Cómo se verá en la barra',
    'web.bookmarks.emoji': 'Emoji (opcional)',
    'web.bookmarks.save': 'Guardar',
    'web.bookmarks.invalidLink': 'Escribe un enlace http o https válido.',
    'web.bookmarks.edit': 'Editar',
    'web.bookmarks.delete': 'Eliminar',
    'web.bookmarks.moveLeft': 'Mover a la izquierda',
    'web.bookmarks.moveRight': 'Mover a la derecha',
    'web.bookmarks.copyLink': 'Copiar enlace',
    'web.bookmarks.menu': 'Opciones de «%@»',
    'web.bookmarks.failed.forbidden': 'No tienes permiso para cambiar los marcadores de este canal.',
    'web.bookmarks.failed.unavailable': 'Este servidor no permite marcadores.',
    'web.bookmarks.failed.invalid': 'El servidor rechazó el marcador. Revisa el enlace.',
    'web.bookmarks.failed.network': 'Sin conexión: no se guardó el cambio.',
    'web.bookmarks.failed.server': 'No se pudo guardar el marcador.',
    'web.bookmarks.deleted': 'Marcador eliminado',
  },
  en: {
    'web.dnd.custom': 'Custom…',
    'web.dnd.until': 'until %@',
    'web.dnd.untilTomorrow': 'until tomorrow %@',
    'web.dnd.untilLater': 'until %1$@ %2$@',
    'web.dnd.customTitle': 'Do not disturb until…',
    'web.dnd.customDate': 'Date',
    'web.dnd.customTime': 'Time',
    'web.dnd.customPast': 'Pick a moment in the future.',
    'web.dnd.customInvalid': 'Check the date and time.',
    'web.dnd.customSave': 'Turn on',
    'web.display.theme': 'Theme',
    'web.display.themeFooter': 'Only in this browser.',
    'web.display.clock24': '24-hour clock',
    'web.display.clock24Hint': 'Shows 14:30 instead of 2:30 PM.',
    'web.display.timezone': 'Time zone',
    'web.display.timezoneAuto': 'Automatic',
    'web.display.timezoneAutoHint': 'Uses this device’s zone: %@',
    'web.display.timezonePick': 'Zone',
    'web.display.timezoneFooter': 'Saved to your account: the server uses it for emails and reminders.',
    'web.display.timezoneFailed': 'Could not change the time zone.',
    'web.security.signOutAll': 'Sign out of all devices',
    'web.security.signOutAllHint': 'Ends every session, this one included. You will need to sign in again on each device.',
    'web.security.signOutAllConfirm': 'Sign out of every session?',
    'web.security.signOutAllFailed': 'Could not sign out of your sessions.',
    'web.search.scope': 'Search in',
    'web.search.scope.messages': 'Messages',
    'web.search.scope.files': 'Files',
    'web.search.files.start': 'Search files by name or content. You can also use ext:pdf, in: and from:.',
    'web.search.files.empty': 'No file matches.',
    'web.search.files.failed': 'Could not search files.',
    'web.search.files.goToMessage': 'Go to message',
    'web.search.files.open': 'Open file',
    'web.bookmarks.bar': 'Channel bookmarks',
    'web.bookmarks.add': 'Add a bookmark',
    'web.bookmarks.addTitle': 'Add bookmark',
    'web.bookmarks.editTitle': 'Edit bookmark',
    'web.bookmarks.link': 'Link',
    'web.bookmarks.linkPlaceholder': 'https://…',
    'web.bookmarks.name': 'Name',
    'web.bookmarks.namePlaceholder': 'How it shows in the bar',
    'web.bookmarks.emoji': 'Emoji (optional)',
    'web.bookmarks.save': 'Save',
    'web.bookmarks.invalidLink': 'Type a valid http or https link.',
    'web.bookmarks.edit': 'Edit',
    'web.bookmarks.delete': 'Delete',
    'web.bookmarks.moveLeft': 'Move left',
    'web.bookmarks.moveRight': 'Move right',
    'web.bookmarks.copyLink': 'Copy link',
    'web.bookmarks.menu': '“%@” options',
    'web.bookmarks.failed.forbidden': 'You are not allowed to change this channel’s bookmarks.',
    'web.bookmarks.failed.unavailable': 'This server does not allow bookmarks.',
    'web.bookmarks.failed.invalid': 'The server refused the bookmark. Check the link.',
    'web.bookmarks.failed.network': 'Offline: the change was not saved.',
    'web.bookmarks.failed.server': 'Could not save the bookmark.',
    'web.bookmarks.deleted': 'Bookmark deleted',
  },
};
